/**
 * ITime.ts
 */
export class TimeData {
    initialise(time, timeZone) {
        this.time = time;
        this.formatter = new Intl.DateTimeFormat([], {
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: false,
            timeZone: timeZone,
        });
    }
    /**
     * Updates the current `time` by adding the elapsed time and returns the updated hours and minutes.
     * If there is no `time` property it defaults to now.
     *
     * @param elapsed - The amount of time (in milliseconds) to add to the current time.
     * @returns `time` as a clock ready [hours, minutes].
     */
    update(elapsed) {
        let hours;
        let minutes;
        if (this.time) {
            this.time += elapsed;
            const timeDate = new Date();
            timeDate.setTime(this.time);
            const formattedTime = this.formatter.format(timeDate);
            hours = parseInt(formattedTime.match(/(\d\d):(\d\d):(\d\d)/)[1], 10);
            minutes = parseInt(formattedTime.match(/(\d\d):(\d\d):(\d\d)/)[2], 10);
        }
        else {
            let now = new Date();
            hours = now.getHours();
            minutes = now.getMinutes();
        }
        return [hours, minutes];
    }
}
//# sourceMappingURL=TimeData.js.map